<template>
	<page-component
	:url="'knd/knd_forms_01/' + this.$route.params.departmentid + '/' + this.$route.params.year + '/' + this.$route.params.month"
	:url-param-id="'kndform01id'"
	entity-name="knd_form_01"
	entity-title="Форма №1"
	title-ref="form_period"
	:parent-url="[
		{ to: '/', text: 'Главная'},
		{ to: '/knd', text: 'Контрольно-надзорная деятельность'},
		{ to: '/knd/knd_forms_01', text: 'Форма №1'},
		{ to: '/knd/knd_forms_01/' + this.$route.params.departmentid, text: this.$route.params.departmentid },
		{ to: '/knd/knd_forms_01/' + this.$route.params.departmentid + '/' + this.$route.params.year, text: this.$route.params.year },
	]"
	/>
</template>
<script>
	export default {
		props: [],
		data: function () {
			return {
			}
		}
	}
</script>